module.exports = __webpack_public_path__ + "static/media/Fire.fbfd62c8.png";